<template>
    <div id="notice">
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="산책스케줄 공지사항">
            <div class="flex justify-end flex-wrap">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-textarea class="w-full" name="memo" v-model="notice1" placeholder="공지사항을 입력해주세요." />
                    </div>
                    <vs-checkbox v-model="no1">
                        산책스케줄 공지 없음
                    </vs-checkbox>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full text-right ">
                        <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="button">
                            <span class="mr-3 mb-2" @click="save('1')">저장</span>
                        </button>
                    </div>
                </div>
            </div>
        </vx-card>
        <vs-divider></vs-divider>
        <vx-card title="힐링센터 공지사항">
            <div class="flex justify-end flex-wrap">
                <div class="vx-col w-full lg:w-1/1 mb-base">
                    <div class="vx-col w-full lg:w-1/1 ">
                        <vs-textarea class="w-full" name="memo" v-model="notice2" placeholder="공지사항을 입력해주세요." />
                    </div>
                    <vs-checkbox v-model="no2">
                        힐링센터 공지 없음
                    </vs-checkbox>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full text-right ">
                        <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="button">
                            <span class="mr-3 mb-2" @click="save('2')">저장</span>
                        </button>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import dateClass from '@/../util/dateClass';
import moment from 'moment';
import 'vue2-datepicker/index.css';
export default {
    components: {},
    data() {
        return {
            notice1: '',
            notice2: '',
            no1: false,
            no2: false,
            width: window.innerWidth,
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        async noticeData() {
            this.$vs.loading({
                type: 'default',
                container: '#notice',
                background: 'rgba(0,0,0,0.1)',
                color: 'primary',
                scale: 1.5,
            });

            const { data } = await axiosClass.get('/api/management/noticeList', {}, true);

            this.notice1 = data.notice1[0]['NOTICE'];
            if (data.notice1[0]['DEL_YN'] == 'Y') {
                this.no1 = true;
            } else {
                this.no1 = false;
            }
            this.notice2 = data.notice2[0]['NOTICE'];
            if (data.notice2[0]['DEL_YN'] == 'Y') {
                this.no2 = true;
            } else {
                this.no2 = false;
            }

            setTimeout(() => {
                this.$vs.loading.close('#notice > .con-vs-loading');
            }, 100);
        },

        async save(type) {
            let notice_content = '';
            let no_boolen = '';
            if (type == 1) {
                notice_content = this.notice1;
                if (this.no1 == true) {
                    no_boolen = 'Y';
                } else {
                    no_boolen = 'N';
                }
            }
            if (type == 2) {
                notice_content = this.notice2;
                if (this.no2 == true) {
                    no_boolen = 'Y';
                } else {
                    no_boolen = 'N';
                }
            }

            const jsonData = {
                type: type,
                notice: notice_content,
                no: no_boolen,
            };
            console.log(jsonData);
            await axiosClass.post('/api/management/noticeSave', jsonData, true);

            setTimeout(() => {
                this.$vs.loading.close('#notice > .con-vs-loading');
            }, 100);

            this.popupActive = false;

            this.$vs.notify({
                title: 'Success',
                text: '정상적으로 등록되었습니다.',
                color: 'success',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
            });
        },
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.noticeData();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    computed: {},
};
</script>

<style></style>
